/**
 * This HOC replicates CSS pseudo states via event handlers and provides their status
 * via props to the child component.
 *
 * For use case and example, see: packages/utilities/styled/README.md
 */

import * as React from 'react';
import {safeCloneElement} from '@packages/utilities/component';

import useHitarea, {
  type State as HitareaState,
} from '@packages/systems/ui/hooks/useHitarea';

type Props = {
  children: (arg1: HitareaState) => React.ReactElement<any>;
};

export default function PseudoProvider(props: Props) {
  // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
  const [state, handlers] = useHitarea();

  return safeCloneElement<any>(handlers, props.children(state));
}
